import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { persistor } from './store';
import { registerPersistor } from './config/apiClient';

// In place before anything renders, so an expired session is purged rather than rehydrated.
registerPersistor(persistor);

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
